
const Format = (number: number | undefined, language: string = 'pt-br') => {
    if (!number) {
        return undefined;
    }

    return new Intl.NumberFormat(language).format(number);
}


const Average = (dividend: number, divisor: number) => {
    if (divisor === 0) {
        return 0;
    }

    return dividend / divisor;
}


const NumberHelper = {
    Format,
    Average
};

export default NumberHelper;